import { useState, useEffect, useReducer } from "react";
import { getSocket } from "../../services/socket-io";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex] = whatsApp;
			return [...state];
		} else {
			return [whatsApp, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/whatsapp/");
				dispatch({ type: "LOAD_WHATSAPPS", payload: data });
				setLoading(false);
			} catch (err) {
				setLoading(false);
				// Silently ignore 403 ERR_NO_COMPANY (superadmin has no tenant)
				if (err?.response?.status !== 403) {
					toastError(err);
				}
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		const socket = getSocket();

		// Re-fetch on reconnect to recover any events missed while disconnected
		const handleReconnect = async () => {
			try {
				const { data } = await api.get("/whatsapp/");
				dispatch({ type: "LOAD_WHATSAPPS", payload: data });
			} catch (_) {}
		};
		socket.on("connect", handleReconnect);

		// DOS handlers distintos sobre el MISMO evento "whatsapp": el off() de cada
		// uno va POR REFERENCIA. Un off("whatsapp") pelado borraría ambos y además
		// los de otros componentes (el socket es el singleton compartido).
		const handleWhatsappUpdate = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
			}
		};

		const handleWhatsappDelete = data => {
			if (data.action === "delete") {
				dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
			}
		};

		const handleWhatsappSession = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		};

		socket.on("whatsapp", handleWhatsappUpdate);
		socket.on("whatsapp", handleWhatsappDelete);
		socket.on("whatsappSession", handleWhatsappSession);

		return () => {
			// SINGLETON getSocket(): NUNCA disconnect().
			socket.off("connect", handleReconnect);
			socket.off("whatsapp", handleWhatsappUpdate);
			socket.off("whatsapp", handleWhatsappDelete);
			socket.off("whatsappSession", handleWhatsappSession);
		};
	}, []);

	return { whatsApps, loading };
};

export default useWhatsApps;
